import { defineIsland } from "../../lib/island";
import { AppHomeApp } from "./App";
import type { HomeUser } from "./types";

export type AppHomeIslandProps = { token: string; user: HomeUser };

export const island = defineIsland<AppHomeIslandProps>("appHomeIsland", AppHomeApp);
